import React from 'react';

import { useSelector } from 'react-redux';

import Button from '@material-ui/core/Button';
import { DescriptionS, HeadingM } from 'components/Typography/Typography';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/billingPaymentTrack/payWithBOMBannerStyle';

import { getBOMLabels } from 'redux/modules/dynamicLabels/selectors';

// @ts-ignore
const useStyle = makeStyles(styles);

const PayWithBOMBanner = () => {
	const classes = useStyle();
	const bomLabels = useSelector(getBOMLabels)?.payWithBOMBanner;

	return (
		<div className={classes.bannerWrapper}>
			<HeadingM customClassName={classes.bannerHeading}>{bomLabels?.tryWithBankMuscatOnlinePayment}</HeadingM>
			<DescriptionS customClassName={classes.bannerDescription}>{bomLabels?.tryWithBankMuscatNote}</DescriptionS>
			<Button href="/dashboard/payments/bills?paymentPreference=BM" className={classes.button}>
				{bomLabels?.payUsingBankMuscat}
			</Button>
		</div>
	);
};

export default PayWithBOMBanner;
